export default "/images/108a326ae3a1dd585ce25cd6f1d5f017.avif";